/*jshint esversion: 6 */
/*! webmd.postMessage */

import debug from 'webmd-debug';
import { getLifecycle }from 'webmd-url';
import { getSLD } from 'webmd-url';

let postMessage;

if (typeof window !== 'undefined') {

	window.webmd = window.webmd || {};

	/**
	 * @namespace postMessage
	 *
	 */
	postMessage = {
		/**
		 * @param vm is optional argument; vue instance.
		 */
		init: function(vm){
			debug("post message listener initialized");

			// global listeners so we don't add these all over the place
			window.addEventListener('message', function (e) {
				let obj;
				var noSurvey = false;
				if(window.location.href && window.location.href.indexOf("overlay=false") > -1){
					noSurvey = true;
				}

				if(window.__INITIAL_STATE__ && window.__INITIAL_STATE__.ads) {
					let vendorConfig = window.__INITIAL_STATE__.ads.vendorConfig;
					if (vendorConfig && vendorConfig.survey && vendorConfig.survey.disable && vendorConfig.survey.disable === true){
						noSurvey= true;
					}
				}
				// post message for survey runner code
				if(e.target.location.origin && e.target.location.origin === window.parent.location.origin) {
					if((e.data.message && e.data.message === 'surveywriter') && e.data.source && !noSurvey){
						if (window && window.webmd) {
							window.webmd.p = {};
							window.webmd.p.pim = require('webmd-pim');
						}
						var tag = document.createElement('script');
						tag.setAttribute('src', e.data.source);
						document.body.appendChild(tag);
					}
				}
				// listen for omniture data from creatives
				if (typeof e.data === 'string' && e.data.indexOf('omniture') > -1) {
					obj = e.data.replace(/'/g, '\"');
					obj = JSON.parse(obj);

					debug('wbmd: omniture', obj.omniture);

					if (obj.omniture) {
						// adhoc metrics`
						if (obj.message && obj.message === 'adhoc') {
								if(vm) {
										vm.$vwmdPageLink({link:obj.omniture}); // vue way of firing omniture
								}
								else{
										wmdPageLink(obj.omniture, obj.omnitureParams);
								}
							// click metrics
						} else {
							window.s_linktext = obj.linktext;
							if(vm) {
									vm.$vwmdTrack({
											sSource: obj.omniture,	// vue way of firing omniture
									});
							}
							else {
									wmdTrack(obj.omniture);
							}
						}
					}
				}

				if (e.data.wbmd) {
					debug('origin: ', e.origin);

					try {
						var theAdFunction = e.data.wbmd.func;
						var element;

							// Code to drop the tap and turn cookie from the aiq.b.1.html file
						if(theAdFunction === 'dropCookies'){
							function _leftPad(str, padString, length) {
								str = ""+str+"";
								while (str.length < length) { str = padString + str; }
								return str;
							}
							function _getDateYYMMDD(date){
								return date.getFullYear().toString().substr(2,2) +
									_leftPad(date.getMonth() + 1,"0",2) +
									_leftPad(date.getDate(),"0",2);
							}
							/*Function to set Cookie*/
							function setCookie(cname, cvalue, exdays) {
								
								var today = _getDateYYMMDD(new Date());
								var d = new Date();
								d.setTime(d.getTime()+(30*24*60*60*1000));
								
								
								var domainName = "domain=" + getSLD();
								if(cname === 'turn'){
									cvalue = cvalue + '|' + today.trim() + "|y";
								}
								//webmd.cookie.set(cname, cvalue, {expires: expires , domain:domainName});
								if(exdays && exdays == 'session'){
									document.cookie = cname + "=" + cvalue + ";" + domainName + ";"   + ";path=/";
								}else{
									var expires = (new Date(new Date().getTime() + (exdays *  24 * 60 * 60 * 1000))).toUTCString();
									document.cookie = cname + "=" + cvalue + ";" + domainName + ";"    + "expires=" +expires + ";path=/";
								}
								
							}
					
							/* Set the cookie 'set_my_cookie'*/
							var cookieDetails = {
								name: e.data.wbmd.cookiename,
								value :  e.data.wbmd.value,
								tapReset : e.data.wbmd.tapReset
							}

							if(e.data.wbmd.cookiename && e.data.wbmd.cookiename == 'TapAd_DID'){
								// drop the cookie only when we have value, if there is no value, then just fire event for ad hoc call
								if(e.data.wbmd.value){
									setCookie(e.data.wbmd.cookiename , e.data.wbmd.value, 'session');
								}
								if(e.data.wbmd.cookiename == 'TapAd_DID'){
									document.dispatchEvent(new CustomEvent('tapAdHoc', {
										detail: cookieDetails
									}));
								}
							}else{
								setCookie(e.data.wbmd.cookiename , e.data.wbmd.value, 'session');
							}
						}
						if (theAdFunction === 'removeAdLabel') {
							var adSlots = window.googletag.pubads().getSlots();
							for (var i = 0; i < adSlots.length; i++) {
								// get the current slot id to add the class name to remove the label
								element = adSlots[i].getSlotElementId();
								var adLabelAdded = document.querySelector('#' + element + ' > div');
								// check if the ad label has been added already
								if (adLabelAdded) {
									adLabelAdded = adLabelAdded.classList.toString().indexOf('remove_content_text');
								}
								if (adLabelAdded === -1) {
									// check if the current ad slot is having removeAdlabel code from dfp
									if (adSlots[i].getHtml().indexOf('removeAdLabel') > -1) {
										document.querySelector('#' + element).classList.add('remove_content_text');
										document.querySelector('#' + element + ' > div').classList.add('remove_content_text');
										var pStyle = window.document.createElement("link");
										pStyle.rel = "preload stylesheet";
										pStyle.as ="style";
										if (getLifecycle() === '.staging') {
											pStyle.href = "//css.staging.webmd.com/dtmcms/staging/webmd/consumer_assets/site_images/ad-border-removal/css/remove-ad-border.css?_=" + new Date().toString().split(' ').slice(0,4).join(' ');
										} else {
											pStyle.href = "//css.webmd.com/dtmcms/live/webmd/consumer_assets/site_images/ad-border-removal/css/remove-ad-border.css?_=" + new Date().toString().split(' ').slice(0,4).join(' ');
										}
										pStyle.id = "remove-ad-border-stylesheet";
										if (window.document.getElementById('remove-ad-border-stylesheet') === null) {
											window.document.getElementsByTagName('head')[0].appendChild(pStyle);
										}

										document.querySelector('#' + element + ' > div').classList.add('remove_border')
									}

								}
							}
						}
						if (theAdFunction === 'makeAdEdgetoEdge' && e.data.pos && (e.data.pos == '2026' || e.data.pos == '1923') || e.data.className == "displayblock") {
							var className = e && e.data ? e.data.className : 'remove_margin';
							var adSlots = window.googletag.pubads().getSlots();
							for (var i = 0; i < adSlots.length; i++) {
								// get the current slot id to add the class name to make ad edge to edge
								element = adSlots[i].getSlotElementId();

								/* class names appended for certain cases like edge to edge or to fit with 
									page content should be removed on ads refresh. 
									Issue is both controversy classes are breaking the drivers */
								if (adSlots[i].getHtml().indexOf('elementfullwidth') > -1) {
									removeClassesOnRefresh(element, 'remove_margin');
								} else if (adSlots[i].getHtml().indexOf('makeAdEdgetoEdge') > -1) {
									removeClassesOnRefresh(element, 'no-full-width');
								}

								var adMarginRemoval = document.querySelector('#' + element);
								// check if the ad margin removal class has been added already
								if (adMarginRemoval) {
									adMarginRemoval = adMarginRemoval.classList.toString().indexOf(className);
								}
								if ((adSlots[i].getTargetingMap().pos[0] === e.data.pos)  && adMarginRemoval === -1 || className == "displayblock") {
									// check if it is having remove margin of ad code from dfp
									if (adSlots[i].getHtml().indexOf('makeAdEdgetoEdge') > -1) {
										document.querySelector('#' + element).classList.add(className);

										if(className == "displayblock") {
											document.querySelector('#' + element + ' > div').classList.add(className);
										}

										var pStyle = window.document.createElement("link");
										pStyle.rel = "preload stylesheet";
										pStyle.as ="style";
										if (getLifecycle() === '.staging') {
											pStyle.href = "//css.staging.webmd.com/dtmcms/staging/webmd/consumer_assets/site_images/ad-border-removal/css/remove-ad-border.css?_=" + new Date().toString().split(' ').slice(0,4).join(' ');
										} else {
											pStyle.href = "//css.webmd.com/dtmcms/live/webmd/consumer_assets/site_images/ad-border-removal/css/remove-ad-border.css?_=" + new Date().toString().split(' ').slice(0,4).join(' ');
										}
										pStyle.id = "remove-ad-border-stylesheet";
										if (window.document.getElementById('remove-ad-border-stylesheet') === null) {
											window.document.getElementsByTagName('head')[0].appendChild(pStyle);
										}
									}

								}
							}
						}
						if (theAdFunction === 'marqueeAdjustAdLabelAndPadding') {
							var pStyle = window.document.createElement("link");
							pStyle.rel = "preload stylesheet";
							pStyle.as ="style";
							if (getLifecycle() === '.staging') {
								pStyle.href = "//img.lb.staging.wbmdstatic.com/webmd_static_vue/file-explorer/webmd/consumer_assets/site_images/dna-marquee2-styles/marquee2-ad-style.css?_=" + new Date().toString().split(' ').slice(0,4).join(' ');
							} else {
								pStyle.href = "//img.lb.wbmdstatic.com/webmd_static_vue/file-explorer/webmd/consumer_assets/site_images/dna-marquee2-styles/marquee2-ad-style.css?_=" + new Date().toString().split(' ').slice(0,4).join(' ');
							}
							pStyle.id = "ad-pos-101-1-marquee-unit-style";
							if (window.document.getElementById('ad-pos-101-1-marquee-unit-style') === null) {
								window.document.getElementsByTagName('head')[0].appendChild(pStyle);
							}
						}

						if (theAdFunction === 'petRxAdjustIframeWidth') {
							var adSlots = window.googletag.pubads().getSlots();
							for (let i = 0; i < adSlots.length; i++) {
								element = adSlots[i].getSlotElementId(); 
								if (element.indexOf("141") > -1) {
									let isPetRx = adSlots[i].getHtml().includes("ad-pet-rx-wrapper");
									
									if (isPetRx) {
										var pRxStyle = window.document.createElement("link");
										pRxStyle.rel = "preload stylesheet";
										pRxStyle.as = "style";
							
										let baseUrl = (getLifecycle() === '.staging') 
											? "//img.lb.staging.wbmdstatic.com/webmd_static_vue/file-explorer/webmd/consumer_assets/site_images/pet-rx/css/pet-rx-style-unit.css"
											: "//img.lb.wbmdstatic.com/webmd_static_vue/file-explorer/webmd/consumer_assets/site_images/pet-rx/css/pet-rx-style-unit.css";
										pRxStyle.href = `${baseUrl}?_=${new Date().toString().split(' ').slice(0, 4).join(' ')}`;
										pRxStyle.id = "ad-pos-141-pet-rx-unit-style";
							
										let petRxDiv = window.document.querySelector('#' + element);
										if (petRxDiv) {
											if (!window.document.getElementById('ad-pos-141-pet-rx-unit-style')) {
												window.document.getElementsByTagName('head')[0].appendChild(pRxStyle);
											}
							
											let petRxIframe = petRxDiv.querySelector("iframe");
											if (petRxIframe) {
												petRxIframe.classList.add("pet-rx-iframe-style");
											} else {
												console.error("No petRx iframe found inside the petRxDiv."); 
											}
										}	
									}
								}
							}
						}

						if (theAdFunction === 'elementfullwidth') {
							var className = e && e.data ? e.data.className : 'displayblock';
							var adSlots = window.googletag.pubads().getSlots();
							for (var i = 0; i < adSlots.length; i++) {
								// get the current slot id to add the class name for specific Unit for full width
								element = adSlots[i].getSlotElementId();

								/* class names appended for certain cases like edge to edge or to fit with 
									page content should be removed on ads refresh. 
									Issue is both controversy classes are breaking the drivers */
								if (adSlots[i].getHtml().indexOf('elementfullwidth') > -1) {
									removeClassesOnRefresh(element, 'remove_margin');
								} else if (adSlots[i].getHtml().indexOf('makeAdEdgetoEdge') > -1) {
									removeClassesOnRefresh(element, 'no-full-width');
								}

								var displayClass = document.querySelector('#' + element + ' > div');
								// check if the displayblock class has been added already
								if (displayClass) {
									displayClass = displayClass.classList.toString().indexOf(className);
								}
								if (displayClass === -1) {
									// check if the current ad slot is serving specific unit which needs full width
									if (adSlots[i].getHtml().indexOf('elementfullwidth') > -1) {
										document.querySelector('#' + element).classList.add(className);
										document.querySelector('#' + element + ' > div').classList.add(className);

										var pStyle = window.document.createElement("link");
										pStyle.rel = "preload stylesheet";
										pStyle.as ="style";
										if (getLifecycle() === '.staging') {
											pStyle.href = "//css.staging.webmd.com/dtmcms/staging/webmd/consumer_assets/site_images/ad-border-removal/css/remove-ad-border.css?_=" + new Date().toString().split(' ').slice(0,4).join(' ');
										} else {
											pStyle.href = "//css.webmd.com/dtmcms/live/webmd/consumer_assets/site_images/ad-border-removal/css/remove-ad-border.css?_=" + new Date().toString().split(' ').slice(0,4).join(' ');
										}
										pStyle.id = "remove-ad-border-stylesheet";
										if (window.document.getElementById('remove-ad-border-stylesheet') === null) {
											window.document.getElementsByTagName('head')[0].appendChild(pStyle);
										}
									}
								}
							}
						}
						if (theAdFunction === 'removeIframe' && e.data.pos && e.data.pos === '2025') {
							document.querySelector('.ad-2025').classList.remove('displayblock');
							document.querySelector('.ad-2025 div').classList.remove('displayblock');
							document.querySelector('.ad-2025 iframe').remove();							
						}
						if (theAdFunction === 'removeInterscroller' && e.data.pos && (e.data.pos == '2026' || e.data.pos == '1923' || e.data.pos == '1926')) {
							let ad2026 = document.querySelectorAll('[data-pos^="2026"]');
							let ad1926 = document.querySelectorAll('[data-pos^="1926"]');
							let ad1923 = document.querySelectorAll('[data-pos^="1923"]');

							function removeClass(adslots) {
								if(adslots && adslots.length > 0) {
									for(let i = 0; i < adslots.length; i++) {
										if (adslots[i].classList.contains('interscroller')) {
											adslots[i].classList.remove('interscroller');
										}
										if (adslots[i].classList.contains('edgetoedgeinterscroller')) {
											adslots[i].classList.remove('edgetoedgeinterscroller');
										}
									}
								}
							}

							removeClass(ad2026);
							removeClass(ad1926);
							removeClass(ad1923);
						}
						if (theAdFunction === 'addInterscroller' && e.data.pos && (e.data.pos == '2026' || e.data.pos == '1923' || e.data.pos == '1926')) {
							var edgetoedgeClass = e && e.data ? e.data.className : '';
							var className = 'interscroller';
							var adSlots = window.googletag.pubads().getSlots();
							for (var i = 0; i < adSlots.length; i++) {
								// get the current slot id to add the class name to make ad interscroller
								element = adSlots[i].getSlotElementId();

								var interscrollerClass = document.querySelector('#' + element);
								// check if the interscroller class has been added already
								if (interscrollerClass) {
									interscrollerClass = interscrollerClass.classList.toString().indexOf(className);
								}
								if ((adSlots[i].getTargetingMap().pos[0] === e.data.pos)  && interscrollerClass === -1) {
									// check if it is having interscroller class of ad code from dfp
									if (adSlots[i].getHtml().indexOf('interscroller') > -1) {
										document.querySelector('#' + element).classList.add(className);
										
										//To make only interscroller unit edge to edge
										document.querySelector('#' + element).classList.add(edgetoedgeClass);
										document.querySelector('#' + element + ' > div').classList.add(edgetoedgeClass);

										var pStyle = window.document.createElement("link");
										pStyle.rel = "preload stylesheet";
										pStyle.as ="style";
										if (getLifecycle() === '.staging') {
											pStyle.href = "//css.staging.webmd.com/dtmcms/staging/webmd/consumer_assets/site_images/ad-border-removal/css/remove-ad-border.css?_=" + new Date().toString().split(' ').slice(0,4).join(' ');
										} else {
											pStyle.href = "//css.webmd.com/dtmcms/live/webmd/consumer_assets/site_images/ad-border-removal/css/remove-ad-border.css?_=" + new Date().toString().split(' ').slice(0,4).join(' ');
										}
										pStyle.id = "remove-ad-border-stylesheet";
										if (window.document.getElementById('remove-ad-border-stylesheet') === null) {
											window.document.getElementsByTagName('head')[0].appendChild(pStyle);
										}
									}

								}
							}						
						}

						// Suggested Module changes
						if (theAdFunction === 'suggestedModule') {
							var moduleHeaderText = e.data.headerText;
							var element = document.querySelector('[id^=lln-toppks]');
							element.querySelector('header > h3').innerText = moduleHeaderText;
						}
					} catch (error) {
						debug('Something went wrong.', error, e);
					}
					/* class names appended for certain cases like edge to edge or to fit with 
						page content should be removed on ads refresh. 
						Issue is both controversy classes are breaking the drivers */
					function removeClassesOnRefresh(element, classtoRemove) {
						if(document.querySelector('#' + element)) {
							document.querySelector('#' + element).classList.remove(classtoRemove);
							document.querySelector('#' + element + ' > div').classList.remove(classtoRemove);
						}
					}
				}

				/*
				* window.parent.postMessage({'isUnStickyDFPServed': true}}, adURl)
				* check the value of isUnStickyDFPServed and if it is true make to add unsticky
				* making the leaderboard ad unsticky when it is made sticky using the sticky plugin
				*/
				if (typeof e.data === 'object' && e.data.isUnStickyDFPServed) {
					if(window.webmd) {
						window.webmd.isUnStickyDFPServed = e.data.isUnStickyDFPServed;
						if(window.webmd.leaderboardStickyPlugin) {
							webmd.leaderboardStickyPlugin.end();
							delete window.webmd.leaderboardStickyPlugin;
							debug("Leaderboard Ad made unsticky via DFP ad-server");
						}
						else {
							debug("window.webmd.leaderboardStickyPlugin is not defined");
							debug("Leaderboard Ad is not made sticky using sticy plugin");
						}
					}
					else {
						debug("window.webmd Object is not defined");
					}
				}

				/**
				 *	New Listener
				* 	Syntax - targetWindow.postMessage(message, targetOrigin, [transfer]);
				*
				* 	@param {string} adURl - The origin of the parent window that sent the message at the time postMessage was called;
				* 	@example
				* 		const adURl = window.parent.location.origin;
				* 		window.parent.postMessage('', adURl);
				*
				* 	@param {object} wbmd - a new object within e.data for WebMD's post-messages
				* 	@example
				* 	window.parent.postMessage({'wbmd': {}}, adURl);
				*
				* 	@param {string} evt - A Custom WebMD Event fired through a post-message
				* 	@example
				* 	window.parent.postMessage({'wbmd': {'evt': 'webmdCustomEvent'}, adURl);
				*
				* 	@param {string} func - The Function name you want the listener to call
				* 	@example
				* 		window.parent.postMessage({'wbmd': {'func': 'readPageHeight'}}, adURl);
				* 		The listener would look inside the wbmd object for the global function readPageHeight() or
				* 		would alternatively be written window["readPageHeight"]();
				*
				* 	@param (string) theIframe - A variable to hold the id of the iframe the ad creative is sitting in;
				* 	@example
				* 		const theIframe = window.frameElement.getAttribute('id');
				*
				* 	@param {string} origin - The origin iFrame id. Note this value requres a friendly iFrame. A safe frame will return null
				* 	@example
				* 		window.parent.postMessage({'wbmd': {'func': 'readPageHeight', 'origin': theIframe}}, adURl);
				* 		The listener would look inside the 'origin' iframe for the function readPageHeight();
				*
				* 	@param {boolean} postback - the default value is false, Tell the listener you want to postMessage back to the iframe
				* 	@example
				* 		window.parent.postMessage({'wbmd': {'func': 'readPageHeight', 'postback': true}}, adURl);
				* 		To Come - To do this we need a way to identify the frame we want to target.
				*
				* 	@param {array} namespace - any additional steps to get tot he function you want to fire
				* 	@example
				* 		window.parent.postMessage({'wbmd': {'func': 'readPageHeight', 'namespace': ['webmd', 'adViewability']}}, adURl);
				* 		The listener would look inside the for the namespaced function webmd.adViewability.readPageHeight();
				* 		the function call would look like this: window['webmd']['adViewability']['readPageHeight']();
				*
				* 	@param {array} options - Any additional parameters you want to pass to the function
				* 	@example
				* 		window.parent.postMessage({'wbmd': {'func': 'readPageHeight', 'options': ['param1', 'param2']}}, adURl);
				* 		The listener would look for the global function readPageHeight('param1', 'param2');.
				* 		To add the params to the function call we utilize JQuery apply() which requires the params as an array.
				* 		the function call would look like this: window[functionCallVar].apply(arrayOfParams);
				*/

				if (e.origin !== window.parent.location.origin) {

				} else if (typeof e.data === 'object' && e.data.wbmd) {
					let theFunction = e.data.wbmd.func || '';			// the function name (string)
					let theEvent = e.data.wbmd.evt || '';				// @TODO the event string
					let theOptions = e.data.wbmd.options || [];			// the options array
					let theNamespace = e.data.wbmd.namespace || [];		// the namespace array
					let theOrigin = e.data.wbmd.origin || '';			// the origin iframe (string). Safe frame returns null
					let postBack = e.data.wbmd.postback || false;		// indicates that there will be a return postMessage
					let thePath = window;

					try {
						if (typeof theFunction === 'string' && Array.isArray(theOptions)) {
							// Call a function in the WebMD Namespace
							if (Array.isArray(theNamespace) && theNamespace.length > 1) {
								for (let i = 0; i < theNamespace.length; i++) {
									thePath = thePath[theNamespace[i]];
								}
								return thePath[theFunction](...theOptions);
							}

							/*
							* Call a function that lives in the ad creative.
							* This implementation currently requires a friendly iframe
							*/
							if (typeof theOrigin === 'string' && theOrigin.length > 1) {
								const theIframe = `iframe[id="${theOrigin}"]` || '';
								document.querySelector(theIframe).contentWindow[theFunction].apply(this, theOptions);
							}

							/*
							* Call a function that lives in the ad creative.
							* This implementation uses a postmessage to send back to the iframe
							*/
							else if (typeof postBack === 'boolean' && postBack === true) {
								//const origin = window.location.origin;

								/*
								* @TODO
								* document.querySelector(theIframe).contentWindow[theFunction].apply(this, theOptions);
								* window.frames[??].frameElement.contentWindow.postMessage({'wbmd': {'func': 'readPageHeight', 'options': ['param1', 'param2']}}, origin);
								*/
							}

							// Call a custom event
							else if (theEvent) {
								// @TODO
							}

							//Avoiding unneccessary logs when the functions were removeAdLabel, elementfullwidth etc.,
							else if (theFunction === "removeAdLabel" || theFunction === "elementfullwidth"
									|| theFunction === "makeAdEdgetoEdge") {
								return;
							}

							// call a global function
							else {
								window[theFunction].apply(this, theOptions);
							}
						}
					} catch (error) {
						debug('Something went wrong. Please check that your function exists and your variables are of the correct type.', e);
					}
				}
			}, false);

		}
	}; // webmd.postMessage

	webmd.postMessage = postMessage; // expose webmd.postMessage
}

export default postMessage;
